import { Navigate, useSearchParams } from 'react-router-dom';
import { getCustomerSession, isCustomerMarkedSignedIn } from '../lib/customerSession';
import './payment.css';

/**
 * Where a gateway's page sends the client back to (InGo ADR 0047:
 * `PAYMENTS_RETURN_URL`, `/pay/return?delivery=…&payment=…`). The address is a
 * hint, never evidence: it only says which delivery to follow, and the
 * payment screen asks the server.
 *
 * - **On the website**, signed in: straight on to that delivery's payment.
 * - **In the phone's card tab**, where nobody is signed in: the app is still
 *   open beneath it and closes the tab itself once paid, so this only says
 *   to go back to it.
 */
export default function PayReturnPage({ signedIn = () => isCustomerMarkedSignedIn() && Boolean(getCustomerSession()) }) {
  const [params] = useSearchParams();
  const delivery = String(params.get('delivery') || '').replace(/\D/g, '');
  const cancelled = params.get('cancelled') === '1';

  if (delivery !== '' && signedIn()) {
    return <Navigate to={`/pay/${delivery}`} replace state={cancelled ? { problem: 'You closed the card page before paying. Nothing was taken.' } : null} />;
  }

  return (
    <main className="pay-page" aria-labelledby="pay-return-title">
      <div className="pay-hero">
        <h1 id="pay-return-title" className="pay-title">
          {cancelled ? 'Nothing was taken' : 'Thank you'}
        </h1>
        <p className="pay-lead">
          {cancelled
            ? 'You left the card page before paying. Go back to InGo to choose another way to pay.'
            : 'Go back to the InGo app: it shows your payment as soon as your bank confirms it.'}
        </p>
      </div>
    </main>
  );
}
